import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import toArray from 'rc-util/lib/Children/toArray';
import { ConfigContext } from './config-provider';
import Avatar from './Avatar';
import Popover from '../../wui-popover/src';
import { SizeContextProvider } from './SizeContext';
var propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
  style: PropTypes.object,
  prefixCls: PropTypes.string,
  maxCount: PropTypes.number,
  maxStyle: PropTypes.object,
  maxPopoverPlacement: PropTypes.oneOf(['top', 'bottom']),

  /*
   * Size of avatar, options: `large`, `small`, `default`
   * or a custom number size
   * */
  size: PropTypes.oneOfType([PropTypes.oneOf(['large', 'small', 'default']), PropTypes.number])
};

var Group = function Group(props) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      maxCount = props.maxCount,
      maxStyle = props.maxStyle,
      size = props.size;
  var prefixCls = getPrefixCls('avatar-group');
  var cls = classNames(prefixCls, className);
  var children = props.children,
      _props$maxPopoverPlac = props.maxPopoverPlacement,
      maxPopoverPlacement = _props$maxPopoverPlac === void 0 ? 'top' : _props$maxPopoverPlac;
  var childrenWithProps = toArray(children).map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: "avatar-key-".concat(index)
    });
  });
  var numOfChildren = childrenWithProps.length;

  if (maxCount && maxCount < numOfChildren) {
    var childrenShow = childrenWithProps.slice(0, maxCount);
    var childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
    childrenShow.push( /*#__PURE__*/React.createElement(Popover, {
      key: "avatar-popover-key",
      content: childrenHidden,
      trigger: "hover",
      placement: maxPopoverPlacement,
      overlayClassName: "".concat(prefixCls, "-popover")
    }, /*#__PURE__*/React.createElement(Avatar, {
      style: maxStyle
    }, "+".concat(numOfChildren - maxCount))));
    return /*#__PURE__*/React.createElement(SizeContextProvider, {
      size: size
    }, /*#__PURE__*/React.createElement("div", {
      className: cls,
      style: props.style
    }, childrenShow));
  }

  return /*#__PURE__*/React.createElement(SizeContextProvider, {
    size: size
  }, /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: props.style
  }, childrenWithProps));
};

Group.propTypes = propTypes;
export default Group;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-avatar/src/Group.js